import { render, staticRenderFns } from "./scatter.vue?vue&type=template&id=20b4d91e"
import script from "./scatter.vue?vue&type=script&lang=js"
export * from "./scatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports